// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}
/* * {
  outline: 1px solid red;
} */

body {
  height: auto;
  background: white;
}

.dashboard {
  display: flex;
  font-family: "Karla", sans-serif;

  /* height: 100vh; */
}

.sidebar {
  width: 50px;
  padding: 10px 30px 10px 20p;
  border-right: 1px solid #ccc;
  background: linear-gradient(
    to bottom,
    rgba(193, 223, 196, 0) 0%,
    rgba(222, 236, 221, 0.9647) 100%
  );
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease-in-out;

  position: absolute;
  left: 4px;
  top: 9px;

  position: fixed;
  height: 100vh;
}

.sidebar:hover {
  width: 160px;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
}

.sidebar-item {
  display: flex;
  align-items: center;
  padding: 11px 13px;
  color: #333;
  transition: background-color 0.3s, padding 0.3s, color 0.3s;
  text-decoration: none;
}

.sidebar-item:hover {
  background-color: #e6e9e8;
}

.sidebar-icon {
  font-size: 22px;
  margin-right: 15px;
}

.sidebar-label {
  font-size: 15px;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  white-space: nowrap;
}

.sidebar:hover .sidebar-label {
  opacity: 1;
}

.sidebar:hover .sidebar-item {
  padding-left: 15px 20px;
}

.main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 93%;
  margin-left: 10px;
  position: absolute;
  left: 67px;
  top: 10px;
  transition: margin-left 0.3s ease-in-out;
  height: 580px;
}

.sidebar:hover ~ .main-content {
  /* margin-left: 250px; */
  width: 85%;
  margin-left: 8%;
}

.top-bar {
  background: rgb(222 236 221);
  padding: 2px 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  position: sticky;
  z-index: 100;
  /* margin-top: 5px; */
}

.top-bar h2 {
  margin: 0;
  margin-left: 26px;
  color: #0d7c66;
  font-weight: bolder;
  font-size: 28px;
}

.user-profile {
  display: flex;
  align-items: center;
  position: relative;
}

.profile-icon-wrapper {
  display: flex;
  color: red;
  align-items: center;
  cursor: pointer;
}

.profile-icon {
  font-size: 36px;
  margin-right: 5px;
  color: #84c7ae;
}
.top-bar {
  max-width: 100%;
  /* width: 100%; */
}
.user-name {
  font-size: 15px;
  color: #0d7c66;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  padding: 5px 10px;
  border-radius: 5px;
}

.profile-dropdown {
  position: absolute;
  top: 116%;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(132, 199, 174, 0.5);
  z-index: 1000;
  width: 180px;
  border-top: 1px solid rgba(132, 199, 174, 1);
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, font-weight 0.3s;
  border-bottom: 1px solid rgba(132, 199, 174, 0.3);
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background-color: rgba(222, 236, 221, 1);
}

.dropdown-item svg {
  margin-right: 10px;
  font-size: 18px;
  color: rgba(132, 199, 174, 1);
}

.dropdown-item span {
  font-size: 14px;
  color: rgba(132, 199, 174, 1);
}

.dropdown-item:hover span {
  font-weight: 500;
  color: black;
}

.dropdown-item:hover svg {
  color: black;
}

.content-area {
  flex-grow: 1;
  padding: 5px;
  position: relative;
  transition: margin-top 0.3s ease;
}

.sidebar-toggle {
  display: none;
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background-color: #84c7ae;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
}

.employee-id {
  font-size: small;
}

/* Desktop styles (1440px and above) */

/* Laptop styles (up to 1024px) */

/* Tablet styles (up to 768px) */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .main-content {
    width: 89%;
    margin-left: 0px;
    transition: all 0.3s ease;
    height: auto;
    display: flex;
    flex-direction: column; /* Important for stacking content properly */
    align-items: stretch;
  }
  .sidebar {
    width: 48px;
    height: 96%;
    z-index: 1000;
  }
  .sidebar-icon {
    font-size: 20px;
    margin-right: 12px;
  }
  .user-name {
    font-size: 14px;
    position: relative;
    left: 6px;
  }

  .profile-icon {
    font-size: 24px;
    margin-right: -70px;
  }
  .sidebar-label {
    font-size: 11px;
    font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    /* white-space: nowrap; */
  }

  .user-profile {
    position: relative;
    /* left: -81px; */
  }

  .top-bar h2 {
    margin-left: 7px;
  }

  .sidebar-item {
    display: flex;
    align-items: center;
    padding: 12px 13px;
    color: #333;
    transition: background-color 0.3s, padding 0.3s, color 0.3s;
    text-decoration: none;
  }
  .sidebar:hover {
    width: 120px;
  }
  /* .main-content {
    min-width: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    width: 114%;
    margin-left: 10px;
    position: absolute;
    left: 67px;
    top: 10px;
    transition: margin-left 0.3s ease-in-out;
  } */

  .sidebar:hover ~ .main-content {
    /* margin-left: 250px; */
    width: 80%;
    margin-left: 9%;
  }

  .top-bar {
    background: rgb(222 236 221);
    padding: 2px 10px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e9ecef;
    position: sticky;
    z-index: 100;
    margin-top: 5px;
  }

  .top-bar h2 {
    margin: 0;
    margin-left: 26px;
    color: #0d7c66;
    font-weight: bolder;
    font-size: 20px;
  }

  .user-profile {
    display: flex;
    align-items: center;
    position: relative;
  }

  .profile-icon-wrapper {
    display: flex;
    color: red;
    align-items: center;
    cursor: pointer;
  }

  .profile-icon {
    font-size: 36px;
    margin-right: 5px;
    color: #84c7ae;
  }

  .user-name {
    font-size: 17px;
    color: #18997f;
    font-weight: 500;
    line-height: 23px;
    /* text-align: left; */
    padding: 5px 10px;
    border-radius: 5px;
  }

  .profile-dropdown {
    position: absolute;
    top: 116%;
    right: 0;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(132, 199, 174, 0.5);
    z-index: 1000;
    width: 180px;
    border-top: 1px solid rgba(132, 199, 174, 1);
  }

  .dropdown-item {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s, font-weight 0.3s;
    border-bottom: 1px solid rgba(132, 199, 174, 0.3);
  }

  .dropdown-item:last-child {
    border-bottom: none;
  }

  .dropdown-item:hover {
    background-color: rgba(222, 236, 221, 1);
  }

  .dropdown-item svg {
    margin-right: 10px;
    font-size: 18px;
    color: rgba(132, 199, 174, 1);
  }

  .dropdown-item span {
    font-size: 14px;
    color: rgba(132, 199, 174, 1);
  }

  .dropdown-item:hover span {
    font-weight: 500;
    color: black;
  }

  .dropdown-item:hover svg {
    color: black;
  }

  .content-area {
    flex-grow: 1;
    padding: 5px;
    position: relative;
    transition: margin-top 0.3s ease;
  }

  .sidebar-toggle {
    display: none;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1000;
    background-color: #84c7ae;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
  }
  .Insights-section h2 {
    color: #6a9c89;
    margin-bottom: 3px;
    font-size: 17px;
  }
  .date-container select {
    padding: 5px 8px;
    /* border: none; */
    font-size: 19px;
    color: black;
    background-color: #fff;
    transition: border-color 0.3s, box-shadow 0.3s;
  }
  .date-container {
    padding: 0px 0px;
    /* border: 2px solid #92e2be; */
    font-size: 14px;
    color: #92e2be;
    background-color: #fff;
    transition: border-color 0.3s, box-shadow 0.3s;
    border-radius: 4px;
  }
  .calendar-clock-container {
    & .calendar {
      & .month-year {
        & h3 {
          margin: 0;
          font-size: 1rem;
          color: rgb(84 141 119);
          font-weight: 600;
        }
      }
    }
  }
  .small-clock {
    width: 142px;
    height: 142px;
  }
}
@media screen and (max-width: 767px) {
  /* .main-content {
    width: 100%;
    margin-left: 0px;
    transition: all 0.3s ease;
    height: auto;
  } */
  .main-content {
    width: 100%;
    margin-left: 0px;
    transition: all 0.3s ease;
    height: auto;
    display: flex;
    flex-direction: column; /* Important for stacking content properly */
    align-items: stretch;
  }
  .profile-icon {
    font-size: 25px;
    margin-right: -7px;
  }
  .top-bar h2 {
    margin-left: 0px;
  }
  /* When sidebar is hovered, only sidebar width changes */
  .sidebar:hover {
    width: 90px;
  }
  .sidebar-label {
    font-size: 10px;
    font-weight: 600;
  }

  /* Optional: If you want main-content to shrink when sidebar expands */
  .sidebar:hover ~ .main-content {
    width: 68%;
    margin-left: 10%;
    font-size: 10px;
  }
  .sidebar:hover .sidebar-icon {
    font-size: 10px; /* smaller icon when sidebar is hovered */
  }

  .sidebar-icon {
    font-size: 20px; /* larger icon when sidebar is not hovered */
    margin-right: 5px;
    transition: font-size 0.3s ease;
  }
  .content-area {
    /* border: 1px solid black; */
    width: 100%;
    height: auto; /* REMOVE fixed height if any */
    /* overflow: scroll; */
  }
  .top-bar {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: rgb(222, 236, 221);
    /* padding: 10px; */
    border-bottom: 1px solid #ccc;
  }

  .top-bar {
    max-width: 100%;
    width: 100%;
  }
  .top-bar h2 {
    font-size: 17px;
    margin-right: 5px;
  }
  .user-name {
    font-size: 8px;
    line-height: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;AACA;;GAEG;;AAEH;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;;EAEhC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B;;;;GAIC;EACD,aAAa;EACb,sBAAsB;EACtB,kCAAkC;;EAElC,kBAAkB;EAClB,SAAS;EACT,QAAQ;;EAER,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wEAAwE;EACxE,UAAU;EACV,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;;EAEjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+DAA+D;EAC/D,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;;AAEtC,iCAAiC;;AAEjC,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB,EAAE,4CAA4C;IACpE,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,WAAW;IACX,aAAa;EACf;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,wEAAwE;IACxE,UAAU;IACV,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,2DAA2D;IAC3D,qBAAqB;EACvB;EACA;IACE,YAAY;EACd;EACA;;;;;;;;;;;KAWG;;EAEH;IACE,wBAAwB;IACxB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;;IAEjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,8CAA8C;IAC9C,aAAa;IACb,YAAY;IACZ,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,+DAA+D;IAC/D,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,8CAA8C;EAChD;EACA;IACE,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,8CAA8C;IAC9C,kBAAkB;EACpB;EACA;IACE;MACE;QACE;UACE,SAAS;UACT,eAAe;UACf,sBAAsB;UACtB,gBAAgB;QAClB;MACF;IACF;EACF;EACA;IACE,YAAY;IACZ,aAAa;EACf;AACF;AACA;EACE;;;;;KAKG;EACH;IACE,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB,EAAE,4CAA4C;IACpE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA,wDAAwD;EACxD;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,sEAAsE;EACtE;IACE,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe,EAAE,yCAAyC;EAC5D;;EAEA;IACE,eAAe,EAAE,4CAA4C;IAC7D,iBAAiB;IACjB,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,WAAW;IACX,YAAY,EAAE,+BAA+B;IAC7C,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;AACF","sourcesContent":["*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n/* * {\n  outline: 1px solid red;\n} */\n\nbody {\n  height: auto;\n  background: white;\n}\n\n.dashboard {\n  display: flex;\n  font-family: \"Karla\", sans-serif;\n\n  /* height: 100vh; */\n}\n\n.sidebar {\n  width: 50px;\n  padding: 10px 30px 10px 20p;\n  border-right: 1px solid #ccc;\n  background: linear-gradient(\n    to bottom,\n    rgba(193, 223, 196, 0) 0%,\n    rgba(222, 236, 221, 0.9647) 100%\n  );\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease-in-out;\n\n  position: absolute;\n  left: 4px;\n  top: 9px;\n\n  position: fixed;\n  height: 100vh;\n}\n\n.sidebar:hover {\n  width: 160px;\n}\n\n.sidebar-nav {\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  padding: 11px 13px;\n  color: #333;\n  transition: background-color 0.3s, padding 0.3s, color 0.3s;\n  text-decoration: none;\n}\n\n.sidebar-item:hover {\n  background-color: #e6e9e8;\n}\n\n.sidebar-icon {\n  font-size: 22px;\n  margin-right: 15px;\n}\n\n.sidebar-label {\n  font-size: 15px;\n  font-family: \"Franklin Gothic Medium\", \"Arial Narrow\", Arial, sans-serif;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  white-space: nowrap;\n}\n\n.sidebar:hover .sidebar-label {\n  opacity: 1;\n}\n\n.sidebar:hover .sidebar-item {\n  padding-left: 15px 20px;\n}\n\n.main-content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  width: 93%;\n  margin-left: 10px;\n  position: absolute;\n  left: 67px;\n  top: 10px;\n  transition: margin-left 0.3s ease-in-out;\n  height: 580px;\n}\n\n.sidebar:hover ~ .main-content {\n  /* margin-left: 250px; */\n  width: 85%;\n  margin-left: 8%;\n}\n\n.top-bar {\n  background: rgb(222 236 221);\n  padding: 2px 10px;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e9ecef;\n  position: sticky;\n  z-index: 100;\n  /* margin-top: 5px; */\n}\n\n.top-bar h2 {\n  margin: 0;\n  margin-left: 26px;\n  color: #0d7c66;\n  font-weight: bolder;\n  font-size: 28px;\n}\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.profile-icon-wrapper {\n  display: flex;\n  color: red;\n  align-items: center;\n  cursor: pointer;\n}\n\n.profile-icon {\n  font-size: 36px;\n  margin-right: 5px;\n  color: #84c7ae;\n}\n.top-bar {\n  max-width: 100%;\n  /* width: 100%; */\n}\n.user-name {\n  font-size: 15px;\n  color: #0d7c66;\n  font-weight: 500;\n  line-height: 18px;\n  text-align: center;\n  padding: 5px 10px;\n  border-radius: 5px;\n}\n\n.profile-dropdown {\n  position: absolute;\n  top: 116%;\n  right: 0;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 4px 8px rgba(132, 199, 174, 0.5);\n  z-index: 1000;\n  width: 180px;\n  border-top: 1px solid rgba(132, 199, 174, 1);\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 15px;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s, font-weight 0.3s;\n  border-bottom: 1px solid rgba(132, 199, 174, 0.3);\n}\n\n.dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.dropdown-item:hover {\n  background-color: rgba(222, 236, 221, 1);\n}\n\n.dropdown-item svg {\n  margin-right: 10px;\n  font-size: 18px;\n  color: rgba(132, 199, 174, 1);\n}\n\n.dropdown-item span {\n  font-size: 14px;\n  color: rgba(132, 199, 174, 1);\n}\n\n.dropdown-item:hover span {\n  font-weight: 500;\n  color: black;\n}\n\n.dropdown-item:hover svg {\n  color: black;\n}\n\n.content-area {\n  flex-grow: 1;\n  padding: 5px;\n  position: relative;\n  transition: margin-top 0.3s ease;\n}\n\n.sidebar-toggle {\n  display: none;\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  z-index: 1000;\n  background-color: #84c7ae;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.employee-id {\n  font-size: small;\n}\n\n/* Desktop styles (1440px and above) */\n\n/* Laptop styles (up to 1024px) */\n\n/* Tablet styles (up to 768px) */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .main-content {\n    width: 89%;\n    margin-left: 0px;\n    transition: all 0.3s ease;\n    height: auto;\n    display: flex;\n    flex-direction: column; /* Important for stacking content properly */\n    align-items: stretch;\n  }\n  .sidebar {\n    width: 48px;\n    height: 96%;\n    z-index: 1000;\n  }\n  .sidebar-icon {\n    font-size: 20px;\n    margin-right: 12px;\n  }\n  .user-name {\n    font-size: 14px;\n    position: relative;\n    left: 6px;\n  }\n\n  .profile-icon {\n    font-size: 24px;\n    margin-right: -70px;\n  }\n  .sidebar-label {\n    font-size: 11px;\n    font-family: \"Franklin Gothic Medium\", \"Arial Narrow\", Arial, sans-serif;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n    /* white-space: nowrap; */\n  }\n\n  .user-profile {\n    position: relative;\n    /* left: -81px; */\n  }\n\n  .top-bar h2 {\n    margin-left: 7px;\n  }\n\n  .sidebar-item {\n    display: flex;\n    align-items: center;\n    padding: 12px 13px;\n    color: #333;\n    transition: background-color 0.3s, padding 0.3s, color 0.3s;\n    text-decoration: none;\n  }\n  .sidebar:hover {\n    width: 120px;\n  }\n  /* .main-content {\n    min-width: 100%;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    width: 114%;\n    margin-left: 10px;\n    position: absolute;\n    left: 67px;\n    top: 10px;\n    transition: margin-left 0.3s ease-in-out;\n  } */\n\n  .sidebar:hover ~ .main-content {\n    /* margin-left: 250px; */\n    width: 80%;\n    margin-left: 9%;\n  }\n\n  .top-bar {\n    background: rgb(222 236 221);\n    padding: 2px 10px;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #e9ecef;\n    position: sticky;\n    z-index: 100;\n    margin-top: 5px;\n  }\n\n  .top-bar h2 {\n    margin: 0;\n    margin-left: 26px;\n    color: #0d7c66;\n    font-weight: bolder;\n    font-size: 20px;\n  }\n\n  .user-profile {\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n\n  .profile-icon-wrapper {\n    display: flex;\n    color: red;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  .profile-icon {\n    font-size: 36px;\n    margin-right: 5px;\n    color: #84c7ae;\n  }\n\n  .user-name {\n    font-size: 17px;\n    color: #18997f;\n    font-weight: 500;\n    line-height: 23px;\n    /* text-align: left; */\n    padding: 5px 10px;\n    border-radius: 5px;\n  }\n\n  .profile-dropdown {\n    position: absolute;\n    top: 116%;\n    right: 0;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-shadow: 0 4px 8px rgba(132, 199, 174, 0.5);\n    z-index: 1000;\n    width: 180px;\n    border-top: 1px solid rgba(132, 199, 174, 1);\n  }\n\n  .dropdown-item {\n    display: flex;\n    align-items: center;\n    padding: 12px 15px;\n    cursor: pointer;\n    transition: background-color 0.3s, color 0.3s, font-weight 0.3s;\n    border-bottom: 1px solid rgba(132, 199, 174, 0.3);\n  }\n\n  .dropdown-item:last-child {\n    border-bottom: none;\n  }\n\n  .dropdown-item:hover {\n    background-color: rgba(222, 236, 221, 1);\n  }\n\n  .dropdown-item svg {\n    margin-right: 10px;\n    font-size: 18px;\n    color: rgba(132, 199, 174, 1);\n  }\n\n  .dropdown-item span {\n    font-size: 14px;\n    color: rgba(132, 199, 174, 1);\n  }\n\n  .dropdown-item:hover span {\n    font-weight: 500;\n    color: black;\n  }\n\n  .dropdown-item:hover svg {\n    color: black;\n  }\n\n  .content-area {\n    flex-grow: 1;\n    padding: 5px;\n    position: relative;\n    transition: margin-top 0.3s ease;\n  }\n\n  .sidebar-toggle {\n    display: none;\n    position: fixed;\n    top: 10px;\n    left: 10px;\n    z-index: 1000;\n    background-color: #84c7ae;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    padding: 10px;\n    cursor: pointer;\n  }\n  .Insights-section h2 {\n    color: #6a9c89;\n    margin-bottom: 3px;\n    font-size: 17px;\n  }\n  .date-container select {\n    padding: 5px 8px;\n    /* border: none; */\n    font-size: 19px;\n    color: black;\n    background-color: #fff;\n    transition: border-color 0.3s, box-shadow 0.3s;\n  }\n  .date-container {\n    padding: 0px 0px;\n    /* border: 2px solid #92e2be; */\n    font-size: 14px;\n    color: #92e2be;\n    background-color: #fff;\n    transition: border-color 0.3s, box-shadow 0.3s;\n    border-radius: 4px;\n  }\n  .calendar-clock-container {\n    & .calendar {\n      & .month-year {\n        & h3 {\n          margin: 0;\n          font-size: 1rem;\n          color: rgb(84 141 119);\n          font-weight: 600;\n        }\n      }\n    }\n  }\n  .small-clock {\n    width: 142px;\n    height: 142px;\n  }\n}\n@media screen and (max-width: 767px) {\n  /* .main-content {\n    width: 100%;\n    margin-left: 0px;\n    transition: all 0.3s ease;\n    height: auto;\n  } */\n  .main-content {\n    width: 100%;\n    margin-left: 0px;\n    transition: all 0.3s ease;\n    height: auto;\n    display: flex;\n    flex-direction: column; /* Important for stacking content properly */\n    align-items: stretch;\n  }\n  .profile-icon {\n    font-size: 25px;\n    margin-right: -7px;\n  }\n  .top-bar h2 {\n    margin-left: 0px;\n  }\n  /* When sidebar is hovered, only sidebar width changes */\n  .sidebar:hover {\n    width: 90px;\n  }\n  .sidebar-label {\n    font-size: 10px;\n    font-weight: 600;\n  }\n\n  /* Optional: If you want main-content to shrink when sidebar expands */\n  .sidebar:hover ~ .main-content {\n    width: 68%;\n    margin-left: 10%;\n    font-size: 10px;\n  }\n  .sidebar:hover .sidebar-icon {\n    font-size: 10px; /* smaller icon when sidebar is hovered */\n  }\n\n  .sidebar-icon {\n    font-size: 20px; /* larger icon when sidebar is not hovered */\n    margin-right: 5px;\n    transition: font-size 0.3s ease;\n  }\n  .content-area {\n    /* border: 1px solid black; */\n    width: 100%;\n    height: auto; /* REMOVE fixed height if any */\n    /* overflow: scroll; */\n  }\n  .top-bar {\n    position: sticky;\n    top: 0;\n    z-index: 999;\n    background-color: rgb(222, 236, 221);\n    /* padding: 10px; */\n    border-bottom: 1px solid #ccc;\n  }\n\n  .top-bar {\n    max-width: 100%;\n    width: 100%;\n  }\n  .top-bar h2 {\n    font-size: 17px;\n    margin-right: 5px;\n  }\n  .user-name {\n    font-size: 8px;\n    line-height: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
